import { Icon } from "./Icon";
import { useI18n } from "../i18n";
import { useOnline } from "../lib/hooks";

/** แถบดำใต้แอปบาร์ แสดงเมื่อออฟไลน์ (จาก navigator.onLine และ event online/offline) */
export function OfflineStrip({ force }: { force?: boolean }) {
  const { t } = useI18n();
  const online = useOnline();
  if (online && !force) return null;
  return (
    <div className="offline-strip" role="status">
      <Icon name="wifiOff" size="sm" />
      <span>{t("offline.strip")}</span>
    </div>
  );
}
